var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"phone-container",class:{'has-validate-error': _vm.hasValidateError}},[_c('div',{staticClass:"phone-input",attrs:{"id":_vm.inputId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }